import ActionCreator from "../../utils/redux/ActionCreator";
import { getUsers, addUser, deleteUser, updateUser, updateAuthUser, getUsersAll } from "../../database/user";

const { actions, defaultReducer, get, add, set, remove, update } = new ActionCreator("user");
export { actions, defaultReducer };

export const getUserData = get(getUsers);
export const getUserAllData = get(getUsersAll);
export const addUserData = add(addUser);
export const updateUserData = update(updateUser);
export const updateAuthUserData = update(updateAuthUser);
export const deleteUserData = remove(deleteUser);
export const setUserDateRange = set('USER-LIST-DATE-RANGE');